/**
 * subscribeAddonModal.tsx
 */
import Addon from '@shared/classes/addon';
import AddonModalContainer from '../../atoms/container/addonModalContainer';
import AddonModalIcon from '../../atoms/images/addonModalIcon';
import AddonModalText from '../../atoms/text/AddonModalText';
import BackgroundMask from '../../atoms/mask/backgroundMask';
import FlavourConfig from '@shared/config/flavours';
import SubscribeAddonModalButtons from '../../elements/modal/subscribeAddonModalButtons';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useCloseModalKeyboard from '@shared/components/utils/hooks/useCloseModalKeyboard';
import { modalSelector } from '@shared/store/slices/modal.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Displays the subscribe addon modal.
 */
export default function SubscribeAddonModal() {
  const { params } = useAppSelector(modalSelector);
  const logo = (params as { addon: Addon })?.addon?.logoColor;
  const title = (params as { addon: Addon })?.addon?.title;

  // Keyboard hooks

  useCloseModalKeyboard();

  return (
    <BackgroundMask opacity={1}>
      <AddonModalContainer margin={true}>
        {logo ? <AddonModalIcon src={logo} /> : null}
        <AddonModalText>
          {TranslationManager.get('MODAL.SUBSCRIBE_ADDON.TITLE', title)}
        </AddonModalText>
        <AddonModalText>
          {TranslationManager.get(
            'MODAL.SUBSCRIBE_ADDON.SUBTITLE',
            FlavourConfig.appTitle
          )}
        </AddonModalText>
        <SubscribeAddonModalButtons />
      </AddonModalContainer>
    </BackgroundMask>
  );
}
